import { createApp } from "vue";
import Profile from "./App.vue";
import router from "./router";
import YoutubeIframe from '@techassi/vue-youtube-iframe';
import myApp from "@/profile/myPlugins/myApp";
import components from "@/profile/components/UI";
import apipa from "@/profile/myPlugins/apipa";
import api2 from "@/profile/myPlugins/api2";
import '@/profile/assets/styles/index.scss';
// import 'bootstrap/dist/css/bootstrap.min.css';

const prof = createApp(Profile);

components.forEach(component => {
    prof.component(component.name, component)
});

prof
    .use(myApp)
    .use(apipa)
    .use(api2)
    .use(router, myApp)
    .use(YoutubeIframe)
    .mount("#profile-vue");
